import i18n from 'i18next';

import { feverErrCodes, highTrafficErrCodes } from 'client/utils/errorObjectChecker';

export const handlers = {
    CLOSE: 'close',
    RELOAD: 'reload',
    LOGOUT_RELOAD: 'logoutReload',
    HIDE_BUTTON: 'hideButton',
    TRY_AGAIN: 'tryAgain',
    PASSCODE_UNVERIFIED: 'passcodeUnverified',
    PASSCODE_DENIED: 'passcodeDenied'
};

const SHOW_SYSTEM_ERROR = 'systemErrorDialog/show_system_error';
const CLOSE_SYSTEM_ERROR = 'systemErrorDialog/close_system_error';

const defaultState = {
    persist: false,
    show: false,
    title: '',
    desc: '',
    handler: ''
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case SHOW_SYSTEM_ERROR:
            return { ...state, show: true, ...(action.payload ?? {}) };
        case CLOSE_SYSTEM_ERROR:
            return state.persist === true
                ? { ...state, show: false }
                : { ...state, ...(action.payload ?? {}) };
        default:
            return state;
    }
};

export default reducer;

export function showErrDialog() {
    return {
        type: SHOW_SYSTEM_ERROR
    };
}

export function closeSystemErrorDialog() {
    return {
        type: CLOSE_SYSTEM_ERROR,
        payload: defaultState
    };
}

export function showCustomErrDialog({
    title,
    desc,
    handler = handlers.CLOSE,
    persist = false
} = {}) {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            persist,
            title,
            desc,
            handler
        }
    };
}

export function showGeneralErrorDialog({
    title = i18n.t('label.system.error'),
    serial,
    code,
    handler = handlers.RELOAD
} = {}) {
    const desc = `
        ${Boolean(serial) ? `${i18n.t('label.error_serial_no')}: ${serial}\n` : ''}${
        Boolean(code) ? `${i18n.t('label.error_code')}: ${code}` : i18n.t('label.try_again_later')
    }
    `.trim();

    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title,
            desc,
            handler
        }
    };
}

export function showGetPromoDataErrorDialog(code) {
    return showGeneralErrorDialog({
        title: highTrafficErrCodes.has(code)
            ? i18n.t('label.system.high_traffic')
            : i18n.t('label.system.busy'),
        code,
        handler: highTrafficErrCodes.has(code) ? handlers.TRY_AGAIN : handlers.RELOAD
    });
}

export function showPromoNotFoundDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.promo_not_found'),
            desc: i18n.t('desc.promo_not_found'),
            handler: handlers.HIDE_BUTTON
        }
    };
}

export function showGetPromoDataErrorAndNoRefreshBtnDialog(code) {
    return showGeneralErrorDialog({
        title: i18n.t('label.system.busy'),
        code,
        handler: code === handlers.HIDE_BUTTON
    });
}

export function showDuplicateGetWinnerErrDialog({ code, serial }) {
    return showGeneralErrorDialog({ title: i18n.t('label.system.busy'), code, serial });
}

export function showUnauthorizedError() {
    return showGeneralErrorDialog();
}

export function showNetworkErrorDialog() {
    return showGeneralErrorDialog();
}

export function showPromoUnavailableCloseDialog() {
    return showGeneralErrorDialog({
        title: i18n.t('label.system.unavailable'),
        handler: handlers.CLOSE
    });
}

export function showPromoNotAvailableErrDialog() {
    return showGeneralErrorDialog({
        title: i18n.t('label.system.unavailable'),
        handler: handlers.RELOAD
    });
}

export function showPromoEndErrDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.promo_is_end'),
            desc: i18n.t('label.see_you_next_time'),
            handler: handlers.RELOAD
        }
    };
}

export function showFormSubmitDuplicateErrDialog() {
    return showGeneralErrorDialog({
        title: i18n.t('label.system.unavailable'),
        code: feverErrCodes.ERR_FORM_DUPLICATE,
        handler: handlers.RELOAD
    });
}

export function showInvalidTestCodeErrorDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.test_mode'),
            desc: i18n.t('desc.test_code_error'),
            handler: handlers.CLOSE
        }
    };
}

export function showUnfufillKKboxOrderDialog(serial) {
    const title = i18n.t('label.system.unavailable');
    const desc = `${i18n.t('label.error_serial_no')}: ${serial}\n${i18n.t(
        'desc.purchase_order_unfufill'
    )}`;

    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title,
            desc,
            handler: handlers.RELOAD
        }
    };
}

export function showContestRecalculatingCacheDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.contest_ugc.vote_rank_recalculating'),
            desc: i18n.t('label.try_again_later'),
            handler: handlers.CLOSE
        }
    };
}

export function showReloginDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            handler: handlers.LOGOUT_RELOAD
        }
    };
}

export function showTooManyAttemptErrDialog(handler = handlers.RELOAD) {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.system.too_many_attempt'),
            desc: i18n.t('label.try_again_later'),
            handler
        }
    };
}

export function showRetryRecaptchaDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.system.error'),
            desc: i18n.t('label.invalid_recaptcha'),
            handler: handlers.CLOSE
        }
    };
}

export function showRecaptchaMissingDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.system.error'),
            desc: i18n.t('label.invalid_recaptcha'),
            handler: handlers.RELOAD
        }
    };
}

export function showMergeFrameFailedDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.upload_failed'),
            desc: i18n.t('label.upload_failed.desc_composite_frame_error'),
            handler: handlers.RELOAD
        }
    };
}
export function showWinnerNotFoundDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.system.error'),
            desc: i18n.t('label.error.winner_not_found'),
            handler: handlers.RELOAD
        }
    };
}

export function showOpenAppAndRedeemPrizeFailDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.system.error'),
            desc: i18n.t('label.missing_in_app_event'),
            handler: handlers.CLOSE
        }
    };
}

export function showLiffAuthFailDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.liff_permission_denied'),
            desc: i18n.t('desc.liff_permission_denied'),
            handler: handlers.HIDE_BUTTON
        }
    };
}

export function showFillFormDuplicateDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.winner_submit_forms_duplicate'),
            desc: i18n.t('desc.winner_submit_forms_duplicate'),
            handler: handlers.RELOAD
        }
    };
}

export function showGetCheckPointCardUnexpectedDialog(uuid) {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.check_point_card.unexpected'),
            desc: `${i18n.t('label.contact_customer_service')}\n${i18n.t(
                'label.check_point_card.code'
            )}: ${uuid}`,
            handler: handlers.RELOAD
        }
    };
}

export function showOpenTaskUnexpectedDialog(uuid) {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.task.unexpected'),
            desc: `${i18n.t('label.contact_customer_service')}\n${i18n.t(
                'label.task.code'
            )}: ${uuid}`,
            handler: handlers.RELOAD
        }
    };
}

export function showEntryFlowExistsDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.system.error'),
            desc: i18n.t('desc.store_game_result.entry_flow_exists'),
            handler: handlers.RELOAD
        }
    };
}

// 點數鎖上鎖中
export function showPointIsLockedErrorDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.system.error'),
            desc: i18n.t('desc.point_is_locked'),
            handler: handlers.RELOAD
        }
    };
}

export function showThirdPartyApiTimedOutDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.system.error'),
            desc: `${i18n.t('label.err.action')} (cURL 28)`,
            handler: handlers.RELOAD
        }
    };
}

export function showTokenErrorDialog() {
    return {
        type: SHOW_SYSTEM_ERROR,
        payload: {
            title: i18n.t('label.system.error'),
            desc: i18n.t('desc.token_error'),
            handler: handlers.RELOAD
        }
    };
}
